import { ImageProps } from 'next/image'
import React, { VFC } from 'react'
import styled, { css } from 'styled-components'

import SVGZoomIn from '@Assets/SVG/ZoomIn'
import { ImageV2 } from '@Components/Image'
import { up } from '@Globals/Style/breakpoints'
import { buttonReset } from '@Globals/Style/mixins'
import { useTranslation } from '@Globals/Translations'

import { SliderProps } from './Slider.interface'

export const StyledZoomInButton = styled.button(({ theme }) => `
  ${buttonReset};
  position: absolute;
  right: 5px;
  bottom: 0px;
  background: transparent !important;
  padding: 10px;

  > svg {
    fill: ${theme.colors.grey};
    width: 24px;
    height: 24px;
    vertical-align: bottom;
  }

  ${up('desktop')} {
    padding: 7px;
    bottom: 5px;

    > svg {
      width: 24px;
      height: 24px;
    }
  }
`)

const ExpandFullWidthHeight = styled.div<{ disabledFullscreen: boolean }>(({ disabledFullscreen }) => css`
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  max-height: 535px;
  max-width: 535px;
  margin: 0 auto;

  ${disabledFullscreen && css`
    min-height: 280px;
    max-height: 280px;
  `};

  ${up('desktop')} {
    max-height: 600px;
    max-width: 600px;
    ${disabledFullscreen && css`
      min-height: 280px;
      max-height: 280px;
    `};
  }


  img {
    width: auto;
    height: auto;
    min-height: 100vw;
    max-height: 600px;


    ${up('desktop')} {
      max-height: 600px;

    }
  }
`)

export const ImageSlide: VFC<SliderProps> = ({
  alt,
  disableFullscreen = false,
  index,
  source,
  splide,
}) => {
  const { t } = useTranslation('cms')

  const onClick = () => {
    splide?.emit('fullscreen', true)
  }
  const options: Partial<ImageProps> = {
    ...(disableFullscreen
      ? {
        layout: 'fill',
        sizes: '280px',
      }
      : {
        height: 1920,
        width: 1920,
        layout: 'responsive',
        sizes: '(min-width: 0px) 535px,(min-width: 900px) 445px, (min-width: 1024px) 590px, 590px',
      }),
  }
  return (
    <ExpandFullWidthHeight disabledFullscreen={disableFullscreen} onClick={onClick}>
      <ImageV2
        alt={alt}
        draggable={false}
        loading={index === 0 ? 'eager' : 'lazy'}
        objectFit="contain"
        priority={index === 0}
        src={source}
        {...options}
      />
      {!disableFullscreen && (
        <StyledZoomInButton aria-label={t('GALLERY_ZOOM_LABEL')}>
          <SVGZoomIn />
        </StyledZoomInButton>
      )}
    </ExpandFullWidthHeight>
  )
}
